export default [
  {
    header: 'LEARN MORE',
    subHeader: 'See how investing in real estate can help you meet your financial goals.',
    linkText: 'BENEFITS OF INVESTING >',
    linkUrl: '/benefits-of-investing',
    borderRight: [0, 0, 0, 1],
    borderColor: 'gray.7',
  },
  {
    header: 'DISCUSS IN PERSON',
    subHeader: 'Speak to a licensed professional about investing in commercial real estate today.',
    linkText: '(877) 781-7062',
    linkUrl: '/contact-us',
    borderRight: [0, 0, 0, 1],
    borderColor: 'gray.7',
  },
  {
    header: 'FAQS',
    subHeader: 'Looking for more answers? Get all your questions answered here.',
    linkText: 'VIEW ALL FAQS >',
    linkUrl: '/knowledge-center/faqs',
  },
];
